<script lang="ts">
	export let expanded = false;
</script>

<svelte:body class={expanded ? 'has-cart-expanded' : 'has-cart'} />

<div class="cart" class:expanded data-testid="cart">
	<div class="c">
		{#if $$slots.header}
			<section class="header">
				<slot name="header" />
			</section>
		{/if}
		<div class="content">
			<section class="padding-topbottom-only-8">
				<slot />
			</section>
		</div>
		<slot name="footer" />
	</div>
</div>
